<template>
  <div class="alert alert-success alert-dismissible" role="alert" v-if="isVisible">
    <button class="close" type="button" data-dismiss="alert" aria-label="Close" @click="hide">
        <span aria-hidden="true">×</span>
    </button>
    <p><em class="icon-check"></em> {{ message }} </p>
  </div>
</template>

<script>
import { Events } from '@/data/static/events';

export default {
  name: 'successAlert',
  data() {
    return {
      isAlertVisible: false,
    };
  },
  methods: {
    hide() {
      this.$emit(Events.HIDE_SUCCESS_ALERT);
    },
  },
  props: {
    isVisible: {
      required: true,
      type: Boolean,
      default: false,
    },
    message: {
      required: true,
      type: String,
    },
  },
};
</script>




// WEBPACK FOOTER //
// SuccessAlert.vue?8579ef88